import React, {
  useEffect,
  useState } 
from "react";

import * as Constants from '../../../components/common/Constants'
import { MainContainer } from "../registration/RegistrationLayout.styled";
import businessLogo from '../../../images/plain-business-logo.svg';
import { PrimaryButton, RegularText, RegularUnderlinedText, SecondaryButton, XXLBoldText } from "../input/TextField.styles";
import { TextField } from "../input";
import ProfileService from "../../../services/ProfileService";
import * as Tagging from '../../../tagging/ForgetPasswordFormTagging';
import Loader from "../../../components/common/Loader";
import { ErrorPage } from "../errorPage/ErrorPage";
import { PopUp } from "../popUp";

import tooltipIcon from '../../../images/info-circle.svg';
import tickIcon from '../../../images/tick-circle.svg';
import { SmallBoldText, YellowWarning } from "./ChangePassword.styles";
import exclamation from '../../../images/exclamation-dark.svg'

const ERROR_MESSAGE = {
  TECHNICAL_ERROR : 'We’re experiencing technical difficulties. Please try again later.'
};

export const ChangePassword = (props) => {

  const [ forgotPasswordDetails, setForgotPasswordDetails ] = useState({});
  const [ enableSubmit, setEnableSubmit ] = useState(false);
  const [ showPassword, setShowPassword] = useState(false);
  const [ confirmDetails, setConfirmDetails ] = useState({});
  const [showPasswordRequirements, setShowPasswordRequirements] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState([]);
  const [ showLoader, setShowLoader ] = useState(false);
  const [ isAnError, setIsAnError ] = useState();
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [ displayView, setDisplayView ] = useState({});
  const [ viewPopup, setViewPopup ] = useState('none');


  const [passwordRequirements, setPasswordRequirements] = useState({
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
  });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const blackCircleIcon = (
    <div style={{
      marginLeft: '2px',
      width: '13px',
      height: '13px',
      borderRadius: '50%',
      border: '1px solid black'
    }}></div>
  );

  useEffect(() => {
    props.setDisplayView({...[], currentDisplay: displayView.currentDisplay})
  }, [displayView]);

  useEffect(() => {
    document.querySelector('html').classList.remove('hide-scroller');   
  })

  useEffect(() => {
    if (!forgotPasswordDetails?.isError && forgotPasswordDetails?.value) {
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);
    }
  }, [ forgotPasswordDetails]);

  const isConfirmPasswordMatch = () => {
    return forgotPasswordDetails.value === confirmDetails.value;
  };

  const submit = (e) => {
    e.preventDefault();
    setShowLoader(true);
    ProfileService.callForgetPassword(props.username, forgotPasswordDetails?.value)
      .then((response) => {
        setShowLoader(false)
        if (response.data.result.successful === true) {
            Tagging.forgetPasswordSuccessEvent();
            setViewPopup('flex');
            setIsSubmitClicked(true);
        } else {
          setShowLoader(false);
          scrollToTop();
          props.setNotificationAlertDisplay('flex');
          props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR)
          Tagging.forgetPasswordErrorEvent(ERROR_MESSAGE.TECHNICAL_ERROR);
        }
      }).catch((error) => {
        scrollToTop();
        setShowLoader(false)
        props.setNotificationAlertDisplay('flex');
        props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR)
        Tagging.forgetPasswordErrorEvent(ERROR_MESSAGE.TECHNICAL_ERROR);
      });

}

  const isValidPassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    return passwordRegex.test(password);
  };

  const toggleShowPassword = () => {
    setShowPassword(prevState => !prevState);
  };

  return (
    <>

      { 
        isAnError ? 
        <ErrorPage
        setIsAnError={setIsAnError}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
        /> :
        <MainContainer>

          { showLoader && 
            <Loader/>
          }
          
          <img width={'100%'} height={props.imageHeight} src={businessLogo} alt="LOGO" />

          <XXLBoldText>Change password</XXLBoldText>
          { 
            (confirmDetails.value && !isConfirmPasswordMatch()) &&
            <YellowWarning>
              <img src={exclamation} alt='warning' width={'21px'} height={'21px'}></img>
              <SmallBoldText>Passwords don’t match</SmallBoldText>
            </YellowWarning>
          }
          <TextField
            inputLabel={'Create password'}
            placeholder={'Enter password'}
            onChange={(e) => {
              const newPassword = e.target.value;
              setForgotPasswordDetails((prevState) => ({
                ...prevState,
                value: newPassword,
                isError: !isValidPassword(newPassword),
              }));

              setPasswordRequirements({
                minLength: newPassword.length >= 8,
                hasUpperCase: /[A-Z]/.test(newPassword),
                hasLowerCase: /[a-z]/.test(newPassword),
                hasNumber: /\d/.test(newPassword),
              });

              if (!isConfirmPasswordMatch){
                setShowPasswordRequirements(false);
              } else {
                setShowPasswordRequirements(true);
              }
            }}
            inLineMessage={forgotPasswordDetails?.message}
            isError={forgotPasswordDetails?.isError}
            value={forgotPasswordDetails?.value}

            isLogin={ true }
            showPassword={ false }
            fieldType="password"
            toggleShowPassword={ toggleShowPassword }
          />

          {showPasswordRequirements && (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignSelf: 'stretch', gap: '6px'}}>

              <label style={{ display: 'flex', alignItems: 'center' }}>
                <img width={'17px'} src={tooltipIcon} alt='tool tip'/>
                <span style={{ marginLeft: '5px' }}>Password requirements:</span>
              </label>

              <label style={{ display: 'flex', alignItems: 'center' }}>

                {passwordRequirements.minLength ?  
                  <img src={tickIcon} alt='' style={{ width: '17px' }}/> 
                  : blackCircleIcon
                }

                <span style={{ marginLeft: '8px' }}>Minimum of 8 characters</span>
              </label>

              <label style={{ display: 'flex', alignItems: 'center' }}>

                {passwordRequirements.hasUpperCase ?  
                  <img src={tickIcon} alt='' style={{ width: '16px' }}/> 
                  : blackCircleIcon
                }
                <span style={{ marginLeft: '8px' }}>1 uppercase character</span>
              </label>

              <label style={{ display: 'flex', alignItems: 'center' }}>

                {passwordRequirements.hasLowerCase ?  
                  <img src={tickIcon} alt='' style={{ width: '16px' }}/> 
                  : blackCircleIcon
                }
                <span style={{ marginLeft: '8px' }}>1 lowercase character</span>
              </label>

              <label style={{ display: 'flex', alignItems: 'center' }}>

                {passwordRequirements.hasNumber ?  
                  <img src={tickIcon} alt='' style={{ width: '16px' }}/> 
                  : blackCircleIcon
                }
                <span style={{ marginLeft: '8px' }}>1 number</span>
              </label>

            </div>
          )}

          <TextField
            inputLabel={'Confirm password'}
            placeholder={'Enter password'}
            onChange={(e) => {
              const newConfirmPassword = e.target.value;
              setConfirmDetails((prevState) => ({
                ...prevState,
                value: newConfirmPassword,
              }));

              if (isConfirmPasswordMatch){
                setShowPasswordRequirements(false);
              } else {
                setShowPasswordRequirements(true);

              }
            }}

            isError={confirmDetails.value && !isConfirmPasswordMatch()}
            isLogin={true}
            showPassword={false}
            fieldType="password"
            toggleShowPassword={ toggleShowPassword }
          />
              
              <div style={{
              'display': 'flex',
              'justifyContent': 'center',
              'alignItems': 'center',
              'gap': '16px',
              'alignSelf': 'stretch'}}>
              <SecondaryButton onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.FORGET_PASSWORD})}
                }>Go back</SecondaryButton>

              <PrimaryButton disabled={!enableSubmit || !isConfirmPasswordMatch()} onClick={ submit }>
                Change password
              </PrimaryButton>
            </div>
            
            <RegularText>
              Don't have an account?&nbsp;
              <RegularUnderlinedText onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.REGISTER})}}>Register</RegularUnderlinedText>
            </RegularText>
        </MainContainer>
      }
      { isSubmitClicked && viewPopup === 'flex' && (
        <>
        <PopUp
          isChangePassword={true}
          message={'You have successfully reset your password.'}
          viewPopup={viewPopup}
          setDisplayView={setDisplayView}
          setViewPopup={setViewPopup}
          accountType={''}
          />
          </>
      )}
    </>
  );
}
